import api from '@/api'

export default {
	async getBoundary(address) {
		try {
			let geoRes = await api.gaode.geo(address);
			let adcode = geoRes.data.geocodes[0].adcode;
			let districtRes = await api.gaode.district(adcode);
			let polyline = districtRes.data.districts[0].polyline;
			polyline = polyline.includes('|') ? polyline.split('|').sort((val1, val2) => val2.length - val1.length)[0] : polyline;
			return polyline.split(';')
		} catch (e) {
			alert('地址检索失败')
		}
	},
	
	gaoToBaidu(data) {
		return data.map(item => {
			let x = item.split(',')[0];
			let y = item.split(',')[1];
			let X_PI = Math.PI * 3000.0 / 180.0;
			let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
			let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
			return {lng: z * Math.cos(theta) + 0.0065, lat: z * Math.sin(theta) + 0.006}
		})
	},
	
	getStorageBoundary(name,key){
		let boundary = localStorage.getItem(name);
		if (boundary && JSON.parse(boundary)[key]) {
			return JSON.parse(boundary)[key];
		}else{
			return null
		}
	},
	
	setStorageBoundary(name,key,value){
		let boundary = localStorage.getItem(name);
		boundary = boundary ? Object.assign(JSON.parse(boundary), {[key]: value}) : {[key]: value};
		localStorage.setItem(name,JSON.stringify((boundary)));
	},
}